import {Component} from 'san';
import styles from './styles.module.less';

export default class TtsBtn extends Component {
    static template = require('./index.html');

    static computed = {
        toastTip() {
            const tip = this.data.get('content');
            return tip.toString().replace(/^\s+|\s+$/gm, '');
        },
    };

    attached() {
        const timerId = setTimeout(() => {
            clearTimeout(timerId);
            this.storeDispatch('hide:toast');
        }, 1000);
    }

    initData() {
        return {
            styles,
            show: false,
        };
    }
}